var Loki = require('lokijs')
var LokiFsStructuredAdapter = require('../node_modules/lokijs/src/loki-fs-structured-adapter.js')

export default {
  override: function () {
    //________________________________________________________________________________________________________________ 
    /**
     * Override di loadDatabase di Loki.js con adapter fs. 
     * Invece di recuperare il file da file system fa una richiesta HTTP.
     */
    Loki.LokiFsAdapter.prototype.loadDatabase = function (dbname, callback) {
      console.log(dbname)
      var self = this
      this.dbref = null;
      var xobj = new XMLHttpRequest();
      xobj.overrideMimeType("application/json");
      // first, load db container component
      xobj.open('GET', dbname, true);
      xobj.onreadystatechange = function () {

        if (xobj.readyState == 4 && (xobj.status == "200" || xobj.status == 200)) {
          if (xobj.responseText != null && xobj.responseText.trim() != '') {
            var res = xobj.responseText;
            self.dbref = res;
            callback(self.dbref);

          } else {
            callback(null);
          }
        }
      };
      xobj.send(null);
    }

    //________________________________________________________________________________________________________________ 
    /**
     * Override di loadDatabaseInternal di Loki.js. 
     * Aggiunge solo la callback a una nuova verisone di loadJSON, così da rendere il parsing dei dati asincrono
     */
    Loki.prototype.loadDatabaseInternal = function (options, callback) {
      var cFun = callback || function (err, data) {
          if (err) {
            throw err;
          }
        },
        self = this;

      // the persistenceAdapter should be present if all is ok, but check to be sure.
      if (this.persistenceAdapter !== null) {

        this.persistenceAdapter.loadDatabase(this.filename, function loadDatabaseCallback(dbString) {
          if (typeof (dbString) === 'string') {
            try {
              self.loadJSONAsync(dbString, options || {}, function () { // custom callback che esegue cFun al suo interno
                cFun(null);
                self.emit('loaded', 'database ' + self.filename + ' loaded');
              });
            } catch (err) {
              cFun(err);
            }
          } else {
            // falsy result means new database
            if (!dbString) {
              cFun(null);
              self.emit('loaded', 'empty database ' + self.filename + ' loaded');
              return;
            }

            // instanceof error means load faulted
            if (dbString instanceof Error) {
              cFun(dbString);
              return;
            }

            // if adapter has returned an js object (other than null or error) attempt to load from JSON object
            if (typeof (dbString) === "object") {
              self.loadJSONObject(dbString, options || {});
              cFun(null); // return null on success
              self.emit('loaded', 'database ' + self.filename + ' loaded');
              return;
            }

            cFun("unexpected adapter response : " + dbString);
          }
        });

      } else {
        cFun(new Error('persistenceAdapter not configured'));
      }
    };

    //________________________________________________________________________________________________________________ 
    /**
     * Nuova funzione loadJSONAsync
     * Accetta una callback che viene eseguita a fine parsing e dopo aver eseguito la loadJSONObject
     * in caso di destructured serialization, viene eseguita a serializzazione finita (da ora asincrona)
     */
    Loki.prototype.loadJSONAsync = function (serializedDb, options, callback) {
      var dbObject;
      if (serializedDb.length === 0) {
        dbObject = {};
        this.loadJSONObject(dbObject, options);
        callback();
      } else {
        // using option defined in instantiated db not what was in serialized db
        switch (this.options.serializationMethod) {
          case "normal":
          case "pretty":
            dbObject = JSON.parse(serializedDb);
            this.loadJSONObject(dbObject, options);
            callback();
            break;
          case "destructured":
            var self = this;
            this.deserializeDestructuredAsync(serializedDb, null, function (dbObject) { // deserializeDestructured accetta una callback
              self.loadJSONObjectAsync(dbObject, options, callback);
            });
            break;
          default:
            dbObject = JSON.parse(serializedDb);
            this.loadJSONObject(dbObject, options);
            callback();
            break;
        }
      }

    };

    //________________________________________________________________________________________________________________ 
    /**
     * Nuova funzione deserializeDestructuredAsync
     * Accetta una callback che viene eseguita a fine serializzazione (passandone il risultato)
     * in questo modo può avvenire in modo asincrono (tramite web worker) e isolare il codice computazionalmente più pesante
     */
    Loki.prototype.deserializeDestructuredAsync = function (destructuredSource, options, callback) {
      var workarray = [];
      var len, cdb;
      var idx, collIndex = 0,
        collCount, lineIndex = 1,
        done = false;
      var currLine, currObject;

      options = options || {};

      if (!options.hasOwnProperty("partitioned")) {
        options.partitioned = false;
      }

      if (!options.hasOwnProperty("delimited")) {
        options.delimited = true;
      }

      if (!options.hasOwnProperty("delimiter")) {
        options.delimiter = this.options.destructureDelimiter;
      }

      // Partitioned
      // DA : Delimited Array of strings [0] db [1] collection [n] collection { partitioned: true, delimited: true }
      // NDAA : Non-Delimited Array with subArrays. db at [0] and collection subarrays at [n] { partitioned: true, delimited : false }
      // -or- single partition
      if (options.partitioned) {
        // handle single partition
        if (options.hasOwnProperty('partition')) {
          // db only
          if (options.partition === -1) {
            cdb = JSON.parse(destructuredSource[0]);
            callback(cdb)
          } else {
            // single collection, return doc array
            cdb = this.deserializeCollection(destructuredSource[options.partition + 1], options);
            callback(cdb)
          }
        } else {
          // Otherwise we are restoring an entire partitioned db
          cdb = JSON.parse(destructuredSource[0]);
          collCount = cdb.collections.length;
          for (collIndex = 0; collIndex < collCount; collIndex++) {
            // attach each collection docarray to container collection data, add 1 to collection array index since db is at 0
            cdb.collections[collIndex].data = this.deserializeCollection(destructuredSource[collIndex + 1], options);
          }
          callback(cdb);
        }
      } else {
        // Non-Partitioned
        // D : one big Delimited string { partitioned: false, delimited : true }
        // NDA : Non-Delimited Array : one iterable array with empty string collection partitions { partitioned: false, delimited: false }

        // D
        var alreadyEnded = false;
        if (options.delimited) {
          workarray = destructuredSource.split(options.delimiter);
          destructuredSource = null; // lower memory pressure
          len = workarray.length;

          if (len === 0) {
            alreadyEnded = true;
            callback(null)
          }
        }
        // NDA
        else {
          workarray = destructuredSource;
        }

        if (!alreadyEnded) {
          if (typeof (Worker) !== "undefined") {
            // Yes! Web worker support!
            var bef = Date.now();
            var worker = new Worker('../../static/js/parseWorker.js');
            worker.addEventListener('message', function (e) {
              console.log("Parse Worker response after: " + (Date.now() - bef));
              self.dbref = e.data;
              callback(self.dbref);
              worker.terminate();
              worker = undefined;
            });
            worker.postMessage(workarray);
          } else {
            // No Web Worker support...
            cdb = JSON.parse(workarray[0]);
            collCount = cdb.collections.length;
            workarray[0] = null;

            while (!done) {
              currLine = workarray[lineIndex];

              // empty string indicates either end of collection or end of file
              if (workarray[lineIndex] === "") {
                // if no more collections to load into, we are done
                if (++collIndex > collCount) {
                  done = true;
                }
              } else {
                currObject = JSON.parse(workarray[lineIndex]);
                cdb.collections[collIndex].data.push(currObject);
              }

              // lower memory pressure and advance iterator
              workarray[lineIndex++] = null;
            }
            callback(cdb);
          }
        }

      }
    };

    //________________________________________________________________________________________________________________ 
    /**
     * Nuova funzione loadJSONObjectAsync
     * Inflates a loki database from a JS object
     * chiamata in loadJSONAsync in caso di deserializedDestrectured
     */
    Loki.prototype.loadJSONObjectAsync = function (dbObject, options, callback) {
      var len = dbObject.collections ? dbObject.collections.length : 0,
        coll,
        copyColl,
        clen,
        j,
        loader,
        collObj;

      this.name = dbObject.name;

      // restore save throttled boolean only if not defined in options
      if (dbObject.hasOwnProperty('throttledSaves') && options && !options.hasOwnProperty('throttledSaves')) {
        this.throttledSaves = dbObject.throttledSaves;
      }

      this.collections = [];

      function makeLoader(coll) {
        var collOptions = options[coll.name];
        var inflater;

        if (collOptions.proto) {
          inflater = collOptions.inflate || Utils.copyProperties;

          return function (data) {
            var collObj = new(collOptions.proto)();
            inflater(data, collObj);
            return collObj;
          };
        }

        return collOptions.inflate;
      }

      var me = this;
      var delayedCollectionLoader = function (i, len) {
        if (i == len) {
          callback()
        } else {
          coll = dbObject.collections[i];

          copyColl = me.addCollection(coll.name, {
            disableChangesApi: coll.disableChangesApi,
            disableDeltaChangesApi: coll.disableDeltaChangesApi,
            disableMeta: coll.disableMeta
          });

          copyColl.adaptiveBinaryIndices = coll.hasOwnProperty('adaptiveBinaryIndices') ? (coll.adaptiveBinaryIndices === true) : false;
          copyColl.transactional = coll.transactional;
          copyColl.asyncListeners = coll.asyncListeners;
          copyColl.cloneObjects = coll.cloneObjects;
          copyColl.cloneMethod = coll.cloneMethod || "parse-stringify";
          copyColl.autoupdate = coll.autoupdate;
          copyColl.changes = coll.changes;

          if (options && options.retainDirtyFlags === true) {
            copyColl.dirty = coll.dirty;
          } else {
            copyColl.dirty = false;
          }

          // load each element individually
          clen = coll.data.length;
          j = 0;
          if (options && options.hasOwnProperty(coll.name)) {
            loader = makeLoader(coll);

            for (j; j < clen; j++) {
              collObj = loader(coll.data[j]);
              copyColl.data[j] = collObj;
              copyColl.addAutoUpdateObserver(collObj);
            }
          } else {

            for (j; j < clen; j++) {
              copyColl.data[j] = coll.data[j];
              copyColl.addAutoUpdateObserver(copyColl.data[j]);
            }
          }

          copyColl.maxId = (typeof coll.maxId === 'undefined') ? 0 : coll.maxId;
          copyColl.idIndex = coll.idIndex;
          if (typeof (coll.binaryIndices) !== 'undefined') {
            copyColl.binaryIndices = coll.binaryIndices;
          }
          if (typeof coll.transforms !== 'undefined') {
            copyColl.transforms = coll.transforms;
          }

          copyColl.ensureId();

          // regenerate unique indexes
          copyColl.uniqueNames = [];
          if (coll.hasOwnProperty("uniqueNames")) {
            copyColl.uniqueNames = coll.uniqueNames;
            for (j = 0; j < copyColl.uniqueNames.length; j++) {
              copyColl.ensureUniqueIndex(copyColl.uniqueNames[j]);
            }
          }

          // reinflate DynamicViews and attached Resultsets
          for (var idx = 0; idx < coll.DynamicViews.length; idx++) {
            var colldv = coll.DynamicViews[idx];

            var dv = copyColl.addDynamicView(colldv.name, colldv.options);
            dv.resultdata = colldv.resultdata;
            dv.resultsdirty = colldv.resultsdirty;
            dv.filterPipeline = colldv.filterPipeline;

            dv.sortCriteria = colldv.sortCriteria;
            dv.sortFunction = null;

            dv.sortDirty = colldv.sortDirty;
            dv.resultset.filteredrows = colldv.resultset.filteredrows;
            dv.resultset.filterInitialized = colldv.resultset.filterInitialized;

            dv.rematerialize({
              removeWhereFilters: true
            });
          }

          // Upgrade Logic for binary index refactoring at version 1.5
          if (dbObject.databaseVersion < 1.5) {
            // rebuild all indices
            copyColl.ensureAllIndexes(true);
            copyColl.dirty = true;
          }
          var next = i + 1;
          setTimeout(function () {
            delayedCollectionLoader(next, len)
          }, 5)
        }
      }
      delayedCollectionLoader(0, len)
    };

    //________________________________________________________________________________________________________________ 
    /**
     * Override di loadDatabase di Loki.js con adapter fs-structured. 
     */
    LokiFsStructuredAdapter.prototype.loadDatabase = function (dbname, callback) {
      var self = this
      this.dbref = null;

      var xobj = new XMLHttpRequest();
      xobj.overrideMimeType("application/json");
      // first, load db container component
      xobj.open('GET', dbname, false);
      xobj.onreadystatechange = function () {

        if (xobj.readyState == 4 && (xobj.status == "200" || xobj.status == 200)) {
          if (xobj.responseText != null && xobj.responseText.trim() != '') {
            self.dbref = JSON.parse(xobj.responseText);

            // when that is done, examine its collection array to sequence loading each

            var iterable = [];
            for (let j = 0; j < self.dbref.collections.length; j++) {
              //function to be executed as async.parallel parameter
              var f = function (cb) {
                var xobj = new XMLHttpRequest();
                xobj.overrideMimeType("application/json");

                xobj.open('GET', dbname + "." + j, true);
                xobj.onreadystatechange = function () {

                  if (xobj.readyState == 4 && (xobj.status == "200" || xobj.status == 200)) {
                    try {
                      if (xobj.responseText != null && xobj.responseText.trim() != '') {
                        var data_object = xobj.responseText;

                        data_object = data_object.split("\n");
                        for (var i = 0; i < data_object.length; i++) {
                          if (data_object[i] != "") {
                            data_object[i] = JSON.parse(data_object[i]);
                          }
                        }
                        if (data_object[data_object.length - 1] == "") {
                          data_object.pop();
                        }
                        self.dbref.collections[j].data = data_object;
                        //result check on data.length
                        cb(null, data_object.length);
                      }
                    } catch (err) {
                      console.log(err)
                      cb(err, null)
                    }
                  } else if (xobj.readyState == 4) {
                    // file does not exist, so callback with null
                    cb(null, null);
                  }
                };
                xobj.send(null);
              }
              iterable.push(f)
            }

            async.parallel(iterable,
              // global callback
              function (err, results) {
                if (err != null) {
                  callback(null);
                } else {
                  callback(self.dbref);
                }
              });
          }
        } else if (xobj.readyState == 4) {
          // file does not exist, so callback with null
          callback(null);
        }
      };
      xobj.send(null);
    }
  }
}



// WEBPACK FOOTER //
// ./src/lokiOverride.js